import { Component, OnInit } from '@angular/core';
import { HelperService } from '../../../Services/helper.service';
import { TranslationService } from "../../../Services/translation.service";

@Component({
  selector: 'app-hometypekitchen',
  templateUrl: './hometypekitchen.component.html',
  styleUrls: ['./hometypekitchen.component.css']
})
export class HometypekitchenComponent implements OnInit {
  // Language
  word: any = {};
  currentCity: string;
  language: string = '';
  city: any;
  constructor(
    private translationService: TranslationService,
    private helperService: HelperService,
  ) {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
    this.city = this.helperService.getCity() || 'sofia';

    const cityList = ['sofia', 'varna', 'plovdiv', 'skopje','beograd'];
    if(cityList.includes(this.city)){
      this.currentCity = this.city;
    }
  }

  ngOnInit(): void { }

}
